import { DropdownMenu, DropdownMenuGroup, DropdownMenuContent, DropdownMenuTrigger, DropdownMenuItem, DropdownMenuSub, DropdownMenuSubContent, DropdownMenuSubTrigger, dropdownMenuItemDestructiveClass } from 'components/ui/dropdown-menu'

import { ConversationMenuIcon } from 'components/blocks/layout/conversation-menu-icon'
import { useState, useEffect } from 'react'

import { InviteUserToGroupModal } from './InviteUserToGroupModal';
import { useRemoveInvitedUser } from '../hooks/use-invite';
import { useLocation } from 'react-router-dom';
import { useParams, useSearchParams } from 'react-router-dom';
import { AlertDialog, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from 'components/ui/alert-dialog';
import { CustomDialog } from 'components/blocks/custom-dialog/custom-dialog';
import { Input } from 'components/ui/input';
import { useToast } from 'hooks/use-toast';
import { useTranslation } from 'react-i18next';
import { useChatStore } from 'state/store/chat/use-chat-store';
import { useAssistantFileViewerStore } from 'state/store/chat/use-assistant-file-viewer-store';
import { useUpdateProject } from 'features/projects/hooks/use-create-project';
import { useProjectOptions } from 'features/projects/hooks/use-projects';
import { useGetConversationById } from 'hooks/use-conversation';
import { useConfig } from 'hooks/use-config';
import { useTheme } from 'components/core/theme-provider';
import { Button } from 'components/ui/button';
import { useCommonStore } from 'state/store/common/useCommonStore'
import { useSubscriptionStore } from 'state/store/subscription/useSubscriptionStore';
import { hasValidGroupChatComponentRoute } from 'pages/services/utilityService';
import { cn } from 'lib/utils';
import { isGroupChatEnabled, isIncognitoChatEnabled } from 'config/feature-flags';
import { DEFAULT_CONVERSATION_NAME } from 'utils/constants/chat-constants';
import {
    conversationHasManualTitle,
    createConversationTitleFromUsersArray,
    resolveConversationDisplayTitle,
    stripConversationDisplayQuotes,
} from 'utils/chat-utilities';
import { deleteConversationById } from 'services/storage-service';
import { useNavigate } from 'react-router-dom';
import { NewProjectModal } from 'features/projects/components/new-project-modal';
import { useQueryClient } from '@tanstack/react-query';
import { refetchProject } from 'features/projects/helpers/query-utils';
import { SidebarTrigger } from 'components/ui/sidebar'
import { UProfileMenu } from 'components/blocks/u-profile-menu'
import { OrgSwitcher } from 'components/blocks/org-switcher'
import { useSidebar } from 'components/ui/sidebar';
import { hasValidPlanForGroupChat, hasValidPlanForStartViaShareLink } from 'pages/services/utilityService';
import { GroupShareModal } from 'features/chat/components/GroupShareModal'
import { ChatPermissionsDialog } from 'features/chat/components/chat-permissions-dialog'
import { useGroupShareModal } from 'hooks/use-group-share-modal'
import { HeaderNotificationBell } from 'pages/main/header/components/HeaderNotificationBell'
import { PendingPaymentBadge } from 'features/subscription/components/pending-payment-badge'
import { Tooltip, TooltipContent, TooltipProvider } from 'components/ui/tooltip'
import { TooltipTrigger } from '@radix-ui/react-tooltip'
import { UserPlus as IconoirUserPlus, NavArrowDown } from 'iconoir-react'
import { AgentChatHeaderTitle } from 'features/chat/components/agent-chat-header-title'
import { AgentSettings } from 'features/chat/components/agent-settings/agent-settings'
import { isAgentChatConversation, resolveConversationAgentId } from 'features/chat/utils/is-agent-chat-conversation'
import { markConversationDeletedLocally, clearLocallyDeletedConversation, removeAgentConversationFromCache, syncConversationRenameCaches } from 'features/chat/utils/agent-sidebar-sync'

export default function GroupChatHeader() {
    const { theme } = useTheme();
    const { t } = useTranslation();
    const { currentPlan } = useSubscriptionStore();
    // console.log('currentPlan', currentPlan)
    const headerTitle = useChatStore((state) => state.headerTitle);
    const isDashboardConversation = useAssistantFileViewerStore(
        (state) => state.isDashboardConversation
    );
    const isDashboardCanvasDismissed = useAssistantFileViewerStore(
        (state) => state.isDashboardCanvasDismissed
    );
    const showDashboardCanvas = isDashboardConversation && !isDashboardCanvasDismissed;
    const activeConversationId = useChatStore((state) => state.activeConversationId);
    const isTitleLoading = useChatStore((state) => state.isTitleLoading);
    const hasParticipants = useChatStore((state) => state.hasParticipant);
    const isNewChat = useChatStore((state) => state.isNewChat);
    const { isMobile, isSidebarOverlay, chatsPanelOpen, setOpenMobile } = useSidebar();
    const showNotificationBell = isSidebarOverlay || !chatsPanelOpen;
    const { pathname } = useLocation();
    // const [showDropdown, setShowDropdown] = useState(false);
    const { setIsIncognitoChat } = useChatStore();


    // const fetchSidebarConversations = useChatStore((state) => state.fetchSidebarConversations);
    const { configurationSettings } = useConfig();
    const { mutateAsync: updateProject, isPending: isUpdatingConversation } = useUpdateProject();
    // const hasAddedAssistantAsParticipant = useChatStore((state) => state.hasAddedAssistantAsParticipant);
    const conversationId = useParams()?.conversationId;
    const projectId = useParams()?.projectId;

    const currentUser = useCommonStore((state) => state.user);

    const [inviteuserModalOpen, setInviteuserModalOpen] = useState(false);
    const setHasParticipant = useChatStore((state) => state.setHasParticipant);
    // const setHasGroupChatParticipantsArray = useChatStore((state) => state.setHasGroupChatParticipantsArray);
    // const setIsLoadingParticipants = useChatStore((state) => state.setIsLoadingParticipants);
    // const [dropdownOpen, setDropdownOpen] = useState(false);
    const [conversationNameDropdownOpen, setConversationNameDropdownOpen] = useState(false);
    const [conversationName, setConversationName] = useState('');
    const [animatedConversationName, setAnimatedConversationName] = useState('');
    const visibleConversationName = stripConversationDisplayQuotes(
        animatedConversationName || conversationName.slice(0, 1)
    );
    const [editDialogOpen, setEditDialogOpen] = useState(false);
    const [editInputValue, setEditInputValue] = useState('');
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const [permissionsDialogOpen, setPermissionsDialogOpen] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const [isAddProjectModalOpen, setIsAddProjectModalOpen] = useState(false);
    const [conversationIdToAddToProject, setConversationIdToAddToProject] = useState<string | undefined>(undefined);
    const queryClient = useQueryClient();
    const removeInvitedUserMutation = useRemoveInvitedUser();
    const navigate = useNavigate();
    const removeConversationFromSidebarById = useChatStore((state) => state.removeConversationFromSidebarById);
    const setNewChat = useChatStore((state) => state.setNewChat);
    const setActiveConversationId = useChatStore((state) => state.setActiveConversationId);
    const disableNewChat = useChatStore((state) => state.disableNewChat);
    const setHasParticipantsArray = useChatStore((state) => state.setHasParticipantsArray);
    const hasParticipantsArray = useChatStore((state) => state.hasParticipantsArray);
    const conversations = useChatStore((state) => state.conversations);
    // console.log('hasParticipantsArray', hasParticipantsArray)

    const [usersData, setUsersData] = useState<any>();
    const updateConversationTitleInStore = useChatStore(
        (state) => state.updateConversationTitleInStore
    );
    const { toast } = useToast();
    const [searchParams] = useSearchParams();
    const isIncognitoChat = searchParams.get('incognito-chat') === 'true';

    const effectiveProjects = useProjectOptions();

    const { data: conversation, isLoading: isLoadingConversation } = useGetConversationById(conversationId as string, isIncognitoChat);

    useEffect(() => {
        setConversationName('');
        setAnimatedConversationName('');
    }, [conversationId]);

    useEffect(() => {
        if (!conversationId) {
            setConversationName('');
            return;
        }

        if (isLoadingConversation) return;

        const manualTitle =
            conversationHasManualTitle(conversation) ||
            !!(conversationId && conversations[conversationId]?.hasManualTitle);
        const isGroupConversation =
            conversations[conversationId]?.isGroupChat === true || hasParticipantsArray.length > 1;
        const storeConversation = conversationId ? conversations[conversationId] : undefined;
        const storedTitle =
            (storeConversation?.hasManualTitle && storeConversation.title) ||
            storeConversation?.title ||
            (activeConversationId === conversationId ? headerTitle : undefined) ||
            conversation?.conversationTitle;

        setConversationName(
            resolveConversationDisplayTitle({
                storedTitle,
                participants: hasParticipantsArray,
                currentUser,
                hasManualTitle: manualTitle,
                isGroupChat: isGroupConversation,
                fallback: '',
            })
        );
    }, [
        conversation,
        isLoadingConversation,
        headerTitle,
        conversationId,
        activeConversationId,
        hasParticipantsArray,
        conversations,
        currentUser,
    ]);

    useEffect(() => {
        if (!conversationName) {
            setAnimatedConversationName('');
            return;
        }

        let nextLength = 0;
        let timeoutId: ReturnType<typeof globalThis.setTimeout> | undefined;
        setAnimatedConversationName('');

        const revealNextCharacter = () => {
            nextLength += 1;
            setAnimatedConversationName(conversationName.slice(0, nextLength));

            if (nextLength < conversationName.length) {
                const nextDelayMs = nextLength < 4 ? 95 : 52;
                timeoutId = globalThis.setTimeout(revealNextCharacter, nextDelayMs);
            }
        };

        timeoutId = globalThis.setTimeout(revealNextCharacter, 140);

        return () => {
            if (timeoutId) {
                globalThis.clearTimeout(timeoutId);
            }
        };
    }, [conversationName]);



    useEffect(() => {
        if (isNewChat) {
            setHasParticipant(false);
            setHasParticipantsArray([]);
            setUsersData('');
            setConversationName('');
            setAnimatedConversationName('');
        }
    }, [isNewChat, setHasParticipant, setHasParticipantsArray]);

    useEffect(() => {
        if (!conversationId) {
            setHasParticipant(false);
            setUsersData("");
            setHasParticipantsArray([]);
            return;
        }
    }, [conversationId, setHasParticipant, setHasParticipantsArray]);




    const removeUser = async (id: string) => {
        if (!conversationId || !id) return;

        let conversationName = '';
        if (conversationHasManualTitle(conversation)) {
            conversationName = conversation?.conversationTitle ?? '';
        } else {
            conversationName = createConversationTitleFromUsersArray(
                hasParticipantsArray.filter((user) => user.itemId != id)
            );
        }

        try {
            const payload = {
                invitationType: 'REMOVE_USER' as const,
                userIds: [id],
                conversationId: conversationId as string,
                conversationTitle: conversationName
            };

            await removeInvitedUserMutation.mutateAsync(payload);
        } catch (error) {
            console.error('Failed to remove user from group:', error);
        }
    }

    // const handleEditClick = () => {
    //     console.log('clicked')
    //     if (conversationId) {
    //         setEditInputValue(conversationName);
    //         setEditDialogOpen(true);
    //     }
    // }
    const onIncognitoClick = () => {
        // setShowDropdown(false);
        if (isMobile) setOpenMobile(false);
        setNewChat(true);
        setIsIncognitoChat(true);
        navigate('/chat?incognito-chat=true');
    };

    const onNewChatClick = () => {
        if (disableNewChat) return;
        if (isMobile) {
            setOpenMobile(false);
        }
        setNewChat(true);
        setIsIncognitoChat(false);
        navigate('/chat');
    };



    const handleUpdateConversationName = async () => {
        if (!conversationId || !editInputValue.trim()) return;

        try {
            const trimmedTitle = editInputValue.trim();
            await updateProject({ payload: { conversationId, conversationTitle: trimmedTitle } });
            updateConversationTitleInStore(conversationId, trimmedTitle, { isManual: true });
            syncConversationRenameCaches(queryClient, conversationId, trimmedTitle);
            setConversationName(trimmedTitle);
            setAnimatedConversationName(trimmedTitle);
            toast({
                variant: 'success',
                title: t('SUCCESS'),
                description: t('RENAME_SUCCESS_DESCRIPTION'),
            });
            // await fetchSidebarConversations(configurationSettings);
            setEditDialogOpen(false);

        }
        catch (error) {
            toast({
                variant: 'destructive',
                title: t('SOMETHING_WENT_WRONG'),
                description: t('FAILED_TO_UPDATE_CONVERSATION_NAME'),
            });
        }
        finally {
            setEditDialogOpen(false);
        }
    }

    const handleDeleteConversation = async () => {
        if (!conversationId) return;

        try {
            setIsDeleting(true);
            // Mark before the API call so the collaboration WS event does not toast again.
            markConversationDeletedLocally(conversationId);
            await deleteConversationById(conversationId, configurationSettings);
            removeConversationFromSidebarById(conversationId);
            removeAgentConversationFromCache(queryClient, conversationId);
            setNewChat(true);
            setActiveConversationId(null);
            navigate('/chat');
            toast({
                variant: 'success',
                title: t('SUCCESS'),
                description: t('DELETE_SUCCESS_DESCRIPTION'),
            });
            setDeleteDialogOpen(false);
        } catch (error) {
            clearLocallyDeletedConversation(conversationId);
            toast({
                variant: 'destructive',
                title: t('DELETE_FAILED'),
                description: t('DELETE_FAILED_DESCRIPTION'),
            });
            console.error('Error deleting conversation:', error);
        } finally {
            setIsDeleting(false);
            setDeleteDialogOpen(false);
        }
    }

    const fetchAndUpdateProjectAllConversations = useChatStore((state) => state.fetchAndUpdateProjectAllConversations);
    const sidebarConversationsList = useChatStore((state) => state.sidebarConversationsList);
    const agentIdFromUrl = searchParams.get('agentId') || searchParams.get('agent');

    const handleAddToProject = async (projectId: string, conversationIdToUse: string) => {
        if (!conversationIdToUse || !projectId) return;

        try {
            const toProject = effectiveProjects.find((p) => p.id === projectId);
            if (!toProject) return;
            const payload = {
                projectId: projectId,
                conversationId: conversationIdToUse,
            };
            await updateProject({ payload: payload, skipInvalidate: true });
            await fetchAndUpdateProjectAllConversations(configurationSettings, projectId);
            removeConversationFromSidebarById(conversationIdToUse);
            if (
                isAgentChatConversation({
                    conversationId: conversationIdToUse,
                    agentIdFromUrl,
                    storeConversation: conversations[conversationIdToUse],
                    sidebarConversationsList,
                })
            ) {
                removeAgentConversationFromCache(queryClient, conversationIdToUse);
            }
            toast({
                variant: 'success',
                title: t('SUCCESS'),
                description: t('MOVE_SUCCESS_DESCRIPTION'),
            });
        } catch (error) {
            toast({
                variant: 'destructive',
                title: t('MOVE_FAILED'),
                description: t('MOVE_FAILED_DESCRIPTION'),
            });
            console.error('Error adding conversation to project:', error);
        }
    }

    const isConversationDropdownDisabled = !hasParticipants && !isLoadingConversation && !conversationId;

    const conversationAgentId = resolveConversationAgentId({
        conversationId,
        agentIdFromUrl,
        storeConversation: conversationId ? conversations[conversationId] : undefined,
        sidebarConversationsList,
    });
    const isAgentChat = !!conversationAgentId;

    const headerConversation = conversationId ? conversations[conversationId] : undefined;
    const isGroupConversation =
        headerConversation?.isGroupChat === true ||
        (headerConversation?.participants?.length ?? 0) > 1 ||
        hasParticipantsArray.length > 1;

    const handleConversationDropdownOpenChange = (open: boolean) => {
        if (!isConversationDropdownDisabled) {
            setConversationNameDropdownOpen(open);
        }
    }

    // if (isLoadingConversation) {
    //     return (
    //         <div className="flex flex-col justify-center items-center w-full">
    //             <LoaderCircle className="text-primary animate-spin" />
    //         </div>
    //     )
    // }

    const {
        showModal,
        setShowModal,
        shareToken,
        setShareToken,
        handleOpenModal
    } = useGroupShareModal(conversationId);

    const handleShareGroupChat = () => {
        handleOpenModal();
    }

    const isAgentChatRoute = pathname.startsWith('/agentChat');
    const isAgentDetailsRoute = pathname.startsWith('/agent-details');
    const isChatRoute = pathname === '/chat' || pathname.startsWith('/chat/');

    return (
        <div className="flex w-full min-w-0 items-center justify-between gap-1 sm:gap-2">

            <div className="flex min-w-0 flex-1 items-center gap-1 overflow-hidden text-sm font-medium">
                <SidebarTrigger className="shrink-0" />

                {isAgentChatRoute ? (
                    <AgentChatHeaderTitle className="min-w-0" />
                ) : null}

                {/* User Images — hidden on narrow screens to preserve title space */}
                {/* {usersData && usersData?.data && usersData?.data?.length > 1 && !isLoadingConversation && (
                    <div className="hidden shrink-0 -space-x-2 sm:flex">
                        {usersData.data.slice(-3).map((user: any, index: number) => (
                            <div key={user.itemId || index} className="relative">
                                {user.profileImageUrl ? (
                                    <img
                                        src={user.profileImageUrl}
                                        alt={`${user.firstName} ${user.lastName}`}
                                        className="w-6 h-6 rounded-full border-2 border-white object-cover"
                                    />
                                ) : (
                                    <div className="w-6 h-6 rounded-full border-2 border-white bg-gray-200 flex items-center justify-center">
                                        {theme === 'dark' ? (
                                            <img src={userParticipant} alt="user participant" className="w-6 h-6" />
                                        ) : (
                                            <img src={userParticipant} alt="user participant" className="w-6 h-6" />
                                        )}
                                    </div>
                                )}
                            </div>
                        ))}

                    </div>
                )} */}

                {isTitleLoading && !isAgentChatRoute && !isAgentDetailsRoute && hasValidGroupChatComponentRoute(pathname) ? (
                    <div
                        className="flex items-center gap-2 rounded-full px-1.5 py-1"
                        role="status"
                        aria-live="polite"
                        aria-label={t('GENERATING_TITLE') || 'Generating title'}
                    >
                        <span className="relative flex h-2.5 w-2.5">
                            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-primary opacity-40" />
                            <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-primary" />
                        </span>
                        <div className="flex items-center gap-1.5">
                            <span className="h-3.5 w-24 animate-pulse rounded-full bg-muted" />
                            <span className="hidden h-3.5 w-10 animate-pulse rounded-full bg-muted/70 sm:inline-block" />
                        </div>
                        <span className="sr-only">{t('GENERATING_TITLE') || 'Generating title'}</span>
                    </div>
                ) : (
                    !isAgentChatRoute && conversationName && hasValidGroupChatComponentRoute(pathname) ? (<>
                        <DropdownMenu modal={false} open={conversationNameDropdownOpen} onOpenChange={handleConversationDropdownOpenChange}>
                            <DropdownMenuTrigger asChild>
                                <button
                                    type="button"
                                    className={`flex min-w-0 max-w-full items-center gap-1 ${theme === 'dark' ? 'text-[#fff]' : 'text-black-500'} ${isConversationDropdownDisabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'}`}
                                    disabled={isConversationDropdownDisabled}
                                >
                                    <span className="min-w-0 truncate text-left text-xs font-medium leading-5 sm:text-sm">
                                        {visibleConversationName}
                                    </span>
                                    <NavArrowDown
                                        width={16}
                                        height={16}
                                        strokeWidth={1.75}
                                        className={cn(
                                            'shrink-0 transition-transform duration-200',
                                            theme === 'dark' ? 'text-[#fff]' : 'text-[#3D3D3D]',
                                            conversationNameDropdownOpen && 'rotate-180'
                                        )}
                                    />
                                </button>
                            </DropdownMenuTrigger>
                            <DropdownMenuContent side="bottom" align="start" className="w-48 rounded-[8px]">
                                <DropdownMenuItem
                                    onClick={() => {
                                        if (conversationId) {
                                            setEditInputValue(conversationName);
                                            setEditDialogOpen(true);
                                            setConversationNameDropdownOpen(false);
                                        }
                                    }}
                                    disabled={!conversationId}
                                >
                                    <ConversationMenuIcon optionId="rename" />
                                    <span>{t('RENAME')}</span>
                                </DropdownMenuItem>
                                {conversationId && !conversations[conversationId]?.isGroupChat && !isAgentChat && (
                                    <DropdownMenuSub>
                                        <DropdownMenuSubTrigger disabled={!conversationId}>
                                            <ConversationMenuIcon optionId="add-to-project" />
                                            <span>{t('ADD_TO_PROJECT')}</span>
                                        </DropdownMenuSubTrigger>
                                        <DropdownMenuSubContent>
                                            <DropdownMenuItem
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    if (conversationId) {
                                                        setIsAddProjectModalOpen(true);
                                                        setConversationIdToAddToProject(conversationId);
                                                    }
                                                }}
                                                disabled={!conversationId}
                                            >
                                                <ConversationMenuIcon optionId="new-project" />
                                                <span>{t('NEW_PROJECT')}</span>
                                            </DropdownMenuItem>
                                            {effectiveProjects.filter((project) => project.id !== projectId).map((project) => (
                                                <DropdownMenuItem
                                                    key={project.id}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        if (conversationId) {
                                                            handleAddToProject(project.id, conversationId);
                                                        }
                                                    }}
                                                    disabled={!conversationId}
                                                >
                                                    <ConversationMenuIcon optionId="folder" />
                                                    <span>{project.name}</span>
                                                </DropdownMenuItem>
                                            ))}
                                        </DropdownMenuSubContent>
                                    </DropdownMenuSub>
                                )}
                                <DropdownMenuItem
                                    onClick={() => {
                                        setPermissionsDialogOpen(true);
                                        setConversationNameDropdownOpen(false);
                                    }}
                                    disabled={!conversationId}
                                >
                                    <ConversationMenuIcon optionId="chat-permissions" />
                                    <span>{t('PERMISSIONS_IN_THIS_CHAT', 'Permissions in this chat')}</span>
                                </DropdownMenuItem>
                                <DropdownMenuItem
                                    onClick={() => setDeleteDialogOpen(true)}
                                    disabled={!conversationId}
                                    className={dropdownMenuItemDestructiveClass}
                                >
                                    <ConversationMenuIcon optionId="delete" />
                                    <span>{t('DELETE')}</span>
                                </DropdownMenuItem>
                            </DropdownMenuContent>
                        </DropdownMenu>
                    </>
                    )
                        : <></>
                )}
            </div>
            <div
                data-testid="chat-header-actions"
                className={cn(
                    'flex shrink-0 items-center gap-3',
                    showDashboardCanvas && 'md:hidden'
                )}
            >

                <PendingPaymentBadge />

                {isChatRoute && <AgentSettings agentId={conversationAgentId} />}

                {isGroupChatEnabled && !isIncognitoChat && (
                    <TooltipProvider>
                        <Tooltip>
                            <TooltipTrigger asChild>
                                <button
                                    type="button"
                                    onClick={() => {
                                        if (hasValidPlanForStartViaShareLink(currentPlan)) {
                                            handleShareGroupChat();
                                        } else {
                                            setInviteuserModalOpen(true);
                                        }
                                    }}
                                    className={cn(
                                        'flex h-7 w-7 shrink-0 cursor-pointer items-center justify-center rounded-full border-[0.5px] p-0 transition-opacity hover:opacity-80 2xl:h-8 2xl:w-8 2xl:p-1.5',
                                        theme === 'dark'
                                            ? 'border-border bg-transparent'
                                            : 'border-grey-200 bg-true-white'
                                    )}
                                    aria-label={t('ADD_PARTICIPANTS') || 'Invite user'}
                                    data-buddy-icon="invite"
                                >
                                    <IconoirUserPlus
                                        width={20}
                                        height={20}
                                        strokeWidth={2}
                                        className={cn(
                                            'size-[18px] 2xl:size-5',
                                            theme === 'dark' ? 'text-true-white' : 'text-grey-500'
                                        )}
                                    />
                                </button>
                            </TooltipTrigger>
                            <TooltipContent>
                                <p>{t('ADD_PARTICIPANTS') || 'Invite user'}</p>
                            </TooltipContent>
                        </Tooltip>
                    </TooltipProvider>
                )}

                <OrgSwitcher />

                {isIncognitoChatEnabled && !isGroupConversation && (
                    <TooltipProvider>
                        <Tooltip>
                            <TooltipTrigger asChild>
                                <button
                                    type="button"
                                    onClick={isIncognitoChat ? onNewChatClick : onIncognitoClick}
                                    className={cn(
                                        'flex h-7 w-7 shrink-0 cursor-pointer items-center justify-center rounded-full p-0 text-primary transition-opacity hover:opacity-80 2xl:h-8 2xl:w-8 2xl:p-1.5',
                                        isIncognitoChat
                                            ? theme === 'dark'
                                                ? 'bg-[#432C05] shadow-[inset_0_0_0_0.25px_#6D6D6D]'
                                                : 'bg-yellow-300 shadow-[inset_0_0_0_0.25px_#6D6D6D]'
                                            : theme === 'dark'
                                                ? 'border border-border bg-transparent'
                                                : 'border border-grey-200 bg-true-white'
                                    )}
                                    aria-label={isIncognitoChat ? (t('INCOGNITO_CHAT_OFF') || 'Turn off incognito') : (t('INCOGNITO_CHAT_ON') || 'Turn on incognito')}
                                    data-buddy-icon="incognito"
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={cn('size-[18px] 2xl:size-5 lucide lucide-hat-glasses-icon lucide-hat-glasses', isIncognitoChat ? 'text-[#432C05] dark:text-[#FDFA12]' : theme === 'dark' ? 'text-true-white' : 'text-grey-500')}><path d="M14 18a2 2 0 0 0-4 0" /><path d="m19 11-2.11-6.657a2 2 0 0 0-2.752-1.148l-1.276.61A2 2 0 0 1 12 4H8.5a2 2 0 0 0-1.925 1.456L5 11" /><path d="M2 11h20" /><circle cx="17" cy="18" r="3" /><circle cx="7" cy="18" r="3" /></svg>
                                </button>
                            </TooltipTrigger>
                            <TooltipContent>
                                <p>{isIncognitoChat ? (t('INCOGNITO_CHAT_OFF') || 'Turn off incognito') : (t('INCOGNITO_CHAT_ON') || 'Turn on incognito')}</p>
                            </TooltipContent>
                        </Tooltip>
                    </TooltipProvider>
                )}

                {/* {
                    isGroupChatEnabled && hasValidGroupChatComponentRoute(pathname) && hasValidPlanForGroupChat(currentPlan) && !projectId && !isIncognitoChat &&
                    <>
                        {
                            hasParticipantsArray?.length > 1 ? (

                                <DropdownMenu modal={false} open={dropdownOpen} onOpenChange={setDropdownOpen}>
                                    <DropdownMenuTrigger asChild>
                                        <div className={`flex cursor-pointer items-center gap-1 rounded-2xl px-1.5 py-[6px] text-xs font-normal leading-[18px] transition-opacity hover:opacity-70 sm:gap-1.5 sm:px-3 sm:text-sm ${theme === 'dark' ? 'text-primary-200' : 'text-primary-600'}`}>
                                            <User className={`h-3.5 w-3.5 shrink-0 ${theme === 'dark' ? 'text-primary-200' : 'text-primary-600'}`} />
                                            <>
                                                <span className="hidden sm:inline">{t('PARTICIPANTS')}</span>
                                                <span className="font-medium">({hasParticipantsArray?.length})</span>
                                                <ChevronDown className={`h-4 w-4 shrink-0 ${theme === 'dark' ? 'text-primary-200' : 'text-primary-600'} transition-transform ${dropdownOpen ? 'rotate-180' : ''}`} />
                                            </>



                                        </div>
                                    </DropdownMenuTrigger>

                                    <DropdownMenuContent className="w-56 rounded-lg p-2 shadow-lg border bg-background" align="end">
                                        <DropdownMenuGroup className=" px-2 py-3">
                                            {isLoadingConversation ? (
                                                <div className='flex items-center gap-2 py-4 justify-center'>
                                                    <Loader2 className='w-4 h-4 animate-spin text-muted-foreground' />
                                                    <p className='text-sm text-muted-foreground'>Loading participants...</p>
                                                </div>
                                            ) : hasParticipantsArray && hasParticipantsArray?.length > 0 ? (
                                                <div className="max-h-56 overflow-y-auto space-y-2 mb-5 pb-2">
                                                    {hasParticipantsArray?.map((user: any, index: number) => (
                                                        <DropdownMenuItem
                                                            key={user.itemId || index}
                                                            className='group flex items-center gap-2 w-full px-[6px] py-0 rounded-md hover:bg-accent focus:bg-accent cursor-default transition-colors'
                                                        >
                                                            <div className="flex-shrink-0">
                                                                {user.profileImageUrl ? (
                                                                    <img
                                                                        src={user.profileImageUrl}
                                                                        alt={`${user.firstName} ${user.lastName}`}
                                                                        className="w-5 h-5 rounded-full object-cover border border-border shadow-sm"
                                                                    />
                                                                ) : (

                                                                    <div className="w-5 h-5 rounded-full bg-muted flex items-center justify-center border border-border">
                                                                        {theme === 'dark' ? (
                                                                            <img src={userParticipant} alt="user participant" className="w-4 h-4" style={{ filter: 'invert(1) brightness(1.2)' }} />
                                                                        ) : (
                                                                            <img src={userParticipant} alt="user participant" className="w-4 h-4" style={{ filter: 'none' }} />
                                                                        )}
                                                                    </div>
                                                                )}
                                                            </div>
                                                            <p className={`font-light text-sm truncate flex-1 min-w-0 ${theme === 'dark' ? 'text-[#ffffff]' : 'text-[#555555]'}`}>
                                                                {user.firstName} {user.lastName}
                                                            </p>
                                                            <AlertDialog>
                                                                <AlertDialogTrigger asChild>
                                                                    <button
                                                                        className="opacity-0 group-hover:opacity-100 transition-all duration-200 p-1.5 rounded-md cursor-pointer "
                                                                        onClick={(e) => e.stopPropagation()}
                                                                        aria-label={`Remove ${user.firstName} ${user.lastName}`}
                                                                    >
                                                                        <X className="w-3.5 h-3.5" />
                                                                    </button>
                                                                </AlertDialogTrigger>
                                                                <AlertDialogContent>
                                                                    <AlertDialogHeader>
                                                                        <AlertDialogTitle>Remove User from Group</AlertDialogTitle>
                                                                        <AlertDialogDescription>
                                                                            Are you sure you want to remove <strong>{user.firstName} {user.lastName}</strong> from this group chat? This action cannot be undone.
                                                                        </AlertDialogDescription>
                                                                    </AlertDialogHeader>
                                                                    <AlertDialogFooter>
                                                                        <Button variant="outline" className="rounded-[6px]">
                                                                            {t('CANCEL')}
                                                                        </Button>
                                                                        <Button
                                                                            variant="default"
                                                                            className="bg-primary rounded-[6px]"
                                                                            onClick={(e) => {
                                                                                e.stopPropagation();
                                                                                removeUser(user.itemId as string);
                                                                            }}
                                                                        >
                                                                            {t('REMOVE')}
                                                                            {removeInvitedUserMutation.isPending && <Loader2 className="animate-spin" />}
                                                                        </Button>

                                                                    </AlertDialogFooter>

                                                                </AlertDialogContent>
                                                            </AlertDialog>
                                                        </DropdownMenuItem>
                                                    ))}
                                                </div>
                                            ) : (

                                                <div className="max-h-64 overflow-y-auto space-y-2 pb-5">
                                                    <DropdownMenuItem
                                                        key={currentUser?.id}
                                                        className='group flex items-center gap-2 w-full px-[6px] py-0 rounded-md hover:bg-accent focus:bg-accent cursor-default transition-colors'
                                                    >
                                                        <div className="flex-shrink-0">
                                                            {currentUser?.profileImageUrl ? (
                                                                <img
                                                                    src={currentUser?.profileImageUrl}
                                                                    alt={`${currentUser?.firstName} ${currentUser?.lastName}`}
                                                                    className="w-5 h-5 rounded-full object-cover border border-border shadow-sm"
                                                                />
                                                            ) : (

                                                                <div className="w-5 h-5 rounded-full bg-muted flex items-center justify-center border border-border">
                                                                    {theme === 'dark' ? (
                                                                        <img src={userParticipant} alt="user participant" className="w-4 h-4" style={{ filter: 'invert(1) brightness(1.2)' }} />
                                                                    ) : (
                                                                        <img src={userParticipant} alt="user participant" className="w-4 h-4" style={{ filter: 'none' }} />
                                                                    )}
                                                                </div>
                                                            )}
                                                        </div>
                                                        <p className={`font-normal text-sm truncate flex-1 min-w-0 ${theme === 'dark' ? 'text-[#ffffff]' : 'text-[#555555]'}`}>
                                                            {currentUser?.firstName} {currentUser?.lastName} (you)
                                                        </p>

                                                    </DropdownMenuItem>
                                                </div>
                                            )}

                                            <div className="">
                                                <button
                                                    className='w-full h-9 rounded-[16px] border border-border bg-background hover:bg-accent hover:border-accent-foreground/20 py-[6px] px-3 flex items-center justify-center gap-2 transition-all disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-background group'
                                                    onClick={() => {
                                                        setDropdownOpen(false);
                                                        if (hasValidPlanForStartViaShareLink(currentPlan)) {
                                                            handleShareGroupChat();
                                                        } else {
                                                            setInviteuserModalOpen(true);
                                                        }
                                                    }}
                                                >
                                                    <UserPlus className='w-4 h-4 text-foreground group-hover:scale-110 transition-transform' />
                                                    <span className={`font-normal text-sm ${theme === 'dark' ? 'text-[#ffffff]' : 'text-[#27272C]'}`}>
                                                        {t('ADD_PARTICIPANTS')}
                                                    </span>
                                                </button>
                                            </div>
                                        </DropdownMenuGroup>
                                    </DropdownMenuContent>
                                </DropdownMenu>
                            ) : (
                                <TooltipProvider>
                                    <Tooltip>
                                        <TooltipTrigger asChild>
                                            <button
                                                onClick={() => {
                                                    setDropdownOpen(false);
                                                    if (hasValidPlanForStartViaShareLink(currentPlan)) {
                                                        handleShareGroupChat();
                                                    } else {
                                                        setInviteuserModalOpen(true);
                                                    }
                                                }}
                                                className={`self-center w-6 h-6  md:self-start rounded-full  sm:rounded-2xl border-[0.5px] ${theme === 'dark' ? 'border-black-500' : 'border-black-100'} md:py-[6px] md:px-3 flex justify-center items-center gap-1.5 cursor-pointer hover:opacity-70 transition-opacity max-h-7 md:w-auto md:h-full`}
                                            >
                                                <MessagesSquare className={`w-3 h-3 ${theme === 'dark' ? 'text-primary-200' : 'text-primary-600'} hidden md:block`} />
                                                <span className={`font-normal text-xs leading-[22px] ${theme === 'dark' ? 'text-primary-200' : 'text-primary-600'} hidden md:block`}>
                                                    {t('CREATE_GROUP_CHAT') || 'Create Group Chat'}
                                                </span>
                                                <UserPlus className={`w-3 h-3 ${theme === 'dark' ? 'text-primary-200' : 'text-primary-600'} block md:hidden`} />
                                            </button>
                                        </TooltipTrigger>
                                        <TooltipContent>
                                            <p>{t('CREATE_GROUP_CHAT') || 'Create Group Chat'}</p>
                                        </TooltipContent>
                                    </Tooltip>
                                </TooltipProvider>
                            )
                        }

                    </>
                } */}
                {showNotificationBell && <HeaderNotificationBell />}

                {/* <TooltipProvider>
                    <Tooltip>
                        <TooltipTrigger asChild>

                            {!isIncognitoChat &&

                                <div onClick={onIncognitoClick} className='flex h-6 w-6 shrink-0 cursor-pointer items-center justify-center self-center rounded-2xl p-1 text-primary'>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-hat-glasses-icon lucide-hat-glasses"><path d="M14 18a2 2 0 0 0-4 0" /><path d="m19 11-2.11-6.657a2 2 0 0 0-2.752-1.148l-1.276.61A2 2 0 0 1 12 4H8.5a2 2 0 0 0-1.925 1.456L5 11" /><path d="M2 11h20" /><circle cx="17" cy="18" r="3" /><circle cx="7" cy="18" r="3" /></svg>
                                </div>
                            }
                        </TooltipTrigger>
                        <TooltipContent>
                            <p>{t('INCOGNITO_CHAT_ON') || 'Turn on incognito'}</p>
                        </TooltipContent>
                    </Tooltip>
                </TooltipProvider>

                <TooltipProvider>
                    <Tooltip>
                        <TooltipTrigger asChild>


                            {isIncognitoChat &&
                                <div onClick={onNewChatClick} className='flex h-6 w-6 shrink-0 cursor-pointer items-center justify-center self-center rounded-2xl p-1'>
                                    <SquarePen />
                                </div>
                            }


                        </TooltipTrigger>
                        <TooltipContent>
                            <p>{t('INCOGNITO_CHAT_OFF') || 'Turn off incognito'}</p>
                        </TooltipContent>
                    </Tooltip>
                </TooltipProvider> */}

                {/* <UProfileMenu isDropdownIconRequired={!isMobile} isFullNameRequired={!isMobile} /> */}


            </div >

            {isGroupChatEnabled && !isIncognitoChat && (
                <InviteUserToGroupModal isOpen={inviteuserModalOpen} onClose={() => setInviteuserModalOpen(false)} />
            )}

            {isGroupChatEnabled && !isIncognitoChat && (
                <GroupShareModal
                    showModal={showModal}
                    setShowModal={setShowModal}
                    shareToken={shareToken}
                    setShareToken={setShareToken}
                    isLoadingConversation={isLoadingConversation}
                />
            )}

            <CustomDialog
                isOpen={editDialogOpen}
                setIsOpen={setEditDialogOpen}
                isLoading={isUpdatingConversation}
                title={t('RENAME')}
                description={''}
                onConfirm={handleUpdateConversationName}
                confirmText={t('UPDATE')}
                cancelText={t('CANCEL')}
                isConfirmDisabled={!editInputValue.trim() || isUpdatingConversation}
            >
                <Input
                    value={editInputValue}
                    onChange={(e) => setEditInputValue(e.target.value)}
                    placeholder={t('CONVERSATION_NAME_PLACEHOLDER')}
                    className="w-full"
                    maxLength={50}
                />
            </CustomDialog>

            <CustomDialog
                isOpen={deleteDialogOpen}
                setIsOpen={setDeleteDialogOpen}
                isLoading={isDeleting}
                title={t('DELETE')}
                description=""
                onConfirm={handleDeleteConversation}
                confirmText={t('YES')}
                cancelText={t('CANCEL')}
            >
                <p>
                    {t('DELETE_CONFIRMATION_DESCRIPTION') || t('CONFIRM_ACTION_DESCRIPTION')}
                </p>
            </CustomDialog>

            {conversationId && (
                <ChatPermissionsDialog
                    conversationId={conversationId}
                    open={permissionsDialogOpen}
                    onOpenChange={setPermissionsDialogOpen}
                />
            )}

            <NewProjectModal
                callback={() => {
                    refetchProject(queryClient, '');
                    if (conversationIdToAddToProject) {
                        removeConversationFromSidebarById(conversationIdToAddToProject);
                        if (
                            isAgentChatConversation({
                                conversationId: conversationIdToAddToProject,
                                agentIdFromUrl,
                                storeConversation: conversations[conversationIdToAddToProject],
                                sidebarConversationsList,
                            })
                        ) {
                            removeAgentConversationFromCache(queryClient, conversationIdToAddToProject);
                        }
                    }
                }}
                newConversatioId={conversationIdToAddToProject}
                isOpen={isAddProjectModalOpen}
                onClose={() => setIsAddProjectModalOpen(false)}
            />
        </div>
    )
}
